module.exports = __webpack_public_path__ + "img/instagramestory5.462cbb3d.jpg";